/* eslint-disable sort-keys */
import { layerValues } from 'packages/styles'

export const gwLayers = {
  monthHeader: layerValues.l1,
  adminPanel: layerValues.l2,
  navTabs: layerValues.l3,
}
